import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './studio/styles/forms.css';  // 전역 폼 스타일
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './studio/contexts/UserContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './studio/lib/queryClient';
import { startPwaInstallPromptCapture } from './studio/services/pwaInstallService';

// React가 마운트되기 전에 일회성 브라우저 설치 이벤트를 보관한다.
startPwaInstallPromptCapture();

// 전역 오류 처리 함수들
const handleError = (event) => {
  console.error('오류 발생:', event.error);
};

const handleUnhandledRejection = (event) => {
  console.error('Promise 오류:', event.reason);
  event.preventDefault();
};

// 전역 오류 리스너 등록
window.addEventListener('error', handleError);
window.addEventListener('unhandledrejection', handleUnhandledRejection);

// 버전 체크는 App 컴포넌트에서 처리

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <UserProvider>
          <App />
        </UserProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

// 서비스 워커 등록 (PWA 기능 활성화)
if ('serviceWorker' in navigator) {
  // 편집 페이지 여부 확인 (플렁슈 편집 중 리로드 방지용)
  const isEditingPage = () => {
    const path = window.location.pathname;
    return path.includes('/flashbook/planche/') || path.includes('/flashbook/edit/');
  };

  const handleServiceWorkerLoad = () => {
    navigator.serviceWorker.register('/sw.js', {
      scope: '/'
    })
      .then((registration) => {
        // 업데이트 확인
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // 편집 중이 아닐 때만 즉시 활성화
              if (!isEditingPage()) {
                newWorker.postMessage('skipWaiting');
              }
            }
          });
        });

        // 대기 중인 SW가 있으면 즉시 활성화 (편집 중이 아닐 때만)
        if (registration.waiting && !isEditingPage()) {
          registration.waiting.postMessage('skipWaiting');
        }
      })
      .catch(() => { });
  };

  // SW 컨트롤러 변경 시 새로고침 (편집 중이면 스킵)
  const handleControllerChange = () => {
    if (isEditingPage()) {
      // 편집 중이면 리로드하지 않고, 다음 페이지 이동 시 자동 적용됨
      return;
    }
    window.location.reload();
  };

  // SW 메시지 수신 (버전 업데이트 알림)
  const handleSWMessage = (event) => {
    if (event.data?.type === 'VERSION_UPDATE') {
      // 편집 중이면 리로드 스킵
      if (isEditingPage()) {
        return;
      }

      // 최근 새로고침 여부 확인 (5초 이내 새로고침 방지)
      const lastReload = sessionStorage.getItem('last_version_reload');
      const now = Date.now();
      if (lastReload && (now - parseInt(lastReload)) < 5000) {
        return;
      }

      localStorage.setItem('app_version', event.data.version);
      sessionStorage.setItem('last_version_reload', now.toString());
      window.location.reload();
    }

    if (event.data?.type === 'PUSH_SUBSCRIPTION_CHANGED') {
      window.dispatchEvent(new CustomEvent('push-subscription-change'));
    }
  };

  // 이벤트 리스너 등록
  window.addEventListener('load', handleServiceWorkerLoad);
  navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);
  navigator.serviceWorker.addEventListener('message', handleSWMessage);
}

reportWebVitals();
